export default __webpack_public_path__ + "static/media/logo-with-text.5b8976af.png";